import axios from 'axios';
import { AppError } from './AppError';
import { captureMessage } from '@shared/lib/sentry';

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

api.interceptors.response.use(
  (response) => {
    
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const serverData = error.response?.data;
    let message = error.message;

    if (serverData && typeof serverData === 'object') {
      message = serverData.message || serverData.error || error.message || 'Error del servidor';
    } else if (!error.response) {
      message = 'Error de conexión. Verifica tu internet e intenta nuevamente.';
    }

    // Solo capturar rate limiting específicamente (otros errores se manejan por AppError)
    if (status === 429) {
      captureMessage(
        `Rate limit exceeded for ${error.config?.url}`,
        'warning',
        {
          api: {
            url: error.config?.url,
            method: error.config?.method,
            status,
          },
        }
      );
    }

    const appError = new AppError(message, status, serverData);
    return Promise.reject(appError);
  }
);

api.interceptors.request.use(
  (config) => {
  
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
); 